// src/config/site.ts — Site officiel Vanessa
// Un seul endroit pour les liens, la navigation et les coordonnées.

export const CONTACT_EMAIL = 'seriquicinee@gmail.com';
export const PUBLISHER = 'ASILLIA';

// L'application Vanessa (Ça Parle, Ça sert, discussion). Modifiable sans
// toucher au code via la variable VITE_APP_URL.
export const APP_URL = (import.meta.env.VITE_APP_URL as string | undefined) || 'https://kinemaplus.com';
export const APP_OPEN_URL = `${APP_URL}/accueil`;

export interface NavLinkItem {
    label: string;
    to: string;
    description?: string;
}

export interface NavGroup {
    label: string;
    to?: string; // lien direct si pas de sous-menu
    items?: NavLinkItem[];
}

export const NAV: NavGroup[] = [
    { label: 'Vanessa', to: '/vanessa' },
    {
        label: 'Produits',
        items: [
            { label: 'Discuter avec Vanessa', to: '/produits/discuter', description: 'Texte, vocal, photo' },
            { label: 'Ça Parle', to: '/produits/ca-parle', description: 'Histoires, réactions, prédictions' },
            { label: 'Ça sert', to: '/produits/ca-sert', description: 'La carte des bons plans' },
            { label: 'Émissions', to: '/produits/emissions', description: 'Conversations vocales' },
            { label: 'Application', to: '/produits/application', description: 'Sur le web, sans rien installer' },
        ],
    },
    {
        label: 'Développeurs',
        items: [
            { label: 'Vue d’ensemble', to: '/developpeurs', description: 'L’API Vanessa en bref' },
            { label: 'Démarrage rapide', to: '/developpeurs/demarrage', description: 'Première requête en 5 minutes' },
            { label: 'Documentation', to: '/documentation', description: 'Référence complète de l’API' },
            { label: 'Tarifs', to: '/tarifs', description: 'Comment obtenir des tokens' },
            { label: 'Statut', to: '/statut', description: 'État du service' },
        ],
    },
    { label: 'Entreprises', to: '/entreprises' },
    {
        label: 'Ressources',
        items: [
            { label: 'Guide d’utilisation', to: '/guide', description: 'Tout savoir sur l’application' },
            { label: 'FAQ', to: '/faq', description: 'Questions fréquentes' },
            { label: 'Confiance & sécurité', to: '/confiance', description: 'Modération, données, règles' },
            { label: 'Contact', to: '/contact', description: 'Écrire à l’équipe' },
        ],
    },
];

export const FOOTER_COLUMNS: { title: string; links: NavLinkItem[] }[] = [
    {
        title: 'Vanessa',
        links: [
            { label: 'Qui est Vanessa', to: '/vanessa' },
            { label: 'Confiance & sécurité', to: '/confiance' },
            { label: 'Contact', to: '/contact' },
        ],
    },
    {
        title: 'Produits',
        links: [
            { label: 'Discuter avec Vanessa', to: '/produits/discuter' },
            { label: 'Ça Parle', to: '/produits/ca-parle' },
            { label: 'Ça sert', to: '/produits/ca-sert' },
            { label: 'Émissions', to: '/produits/emissions' },
        ],
    },
    {
        title: 'Développeurs',
        links: [
            { label: 'Démarrage rapide', to: '/developpeurs/demarrage' },
            { label: 'Documentation', to: '/documentation' },
            { label: 'Tarifs', to: '/tarifs' },
            { label: 'Statut', to: '/statut' },
            { label: 'Console', to: '/console' },
        ],
    },
    {
        title: 'Entreprises',
        links: [
            { label: 'Partenariats', to: '/entreprises' },
            { label: 'Guide d’utilisation', to: '/guide' },
            { label: 'FAQ', to: '/faq' },
        ],
    },
    {
        title: 'Légal',
        links: [
            { label: 'Confidentialité', to: '/confidentialite' },
            { label: 'Conditions d’utilisation', to: '/conditions' },
            { label: 'Règles de la communauté', to: '/confiance#regles' },
        ],
    },
];
